import styled from 'styled-components'

export const Container = styled.div`
  display: inline-block;
  align-self: center !important;
  /* padding-top: 5px !important; */
  /* margin-top: 10px; */
  margin: '0px 24px';
`
